import { STARTINFOS_SERVICE } from "@/services/startInfos.service.js";

const state = {postStartInfoOutput: false, getStartInfosOutput: {}, putStartInfoOutput: false, getStartInfoDetailsOutput: {}, deleteStartInfoByIdOutput: false, getStartInfoBySlugOutput: {}};

const actions = {
    //Service to create startInfos
    postStartInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postStartInfoRequest');
        
        STARTINFOS_SERVICE.postStartInfo(input)
            .then(
                output => {
                    commit('postStartInfoSuccess', output);
                },
                error => {
                    commit('postStartInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated startInfos
    getStartInfos({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStartInfosRequest');

        STARTINFOS_SERVICE.getStartInfos(queryParams)
            .then(
                output => {
                    commit('getStartInfosSuccess', output);
                },
                error => {
                    commit('getStartInfosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update startInfos
    putStartInfo({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putStartInfoRequest');

        STARTINFOS_SERVICE.putStartInfo(input)
            .then(
                output => {
                    commit('putStartInfoSuccess', output);
                },
                error => {
                    commit('putStartInfoFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get startInfo details
    getStartInfoDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getStartInfoDetailsRequest');

        STARTINFOS_SERVICE.getStartInfoDetails(queryParams)
            .then(
                output => {
                    commit('getStartInfoDetailsSuccess', output);
                },
                error => {
                    commit('getStartInfoDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete startInfos
    deleteStartInfoById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteStartInfoByIdRequest');

        STARTINFOS_SERVICE.deleteStartInfoById(id)
            .then(
                output => {
                    commit('deleteStartInfoByIdSuccess', output);
                },
                error => {
                    commit('deleteStartInfoByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postStartInfo
    postStartInfoRequest(state) {
        state.postStartInfoOutput = null;
    },
    postStartInfoSuccess(state, output) {
        state.postStartInfoOutput = true;
    },
    postStartInfoFailure(state) {
        state.postStartInfoOutput = false;
    },

    //getStartInfos
    getStartInfosRequest(state) {
    },
    getStartInfosSuccess(state, output) {
        state.getStartInfosOutput = output;
    },
    getStartInfosFailure(state) {
        state.getStartInfosOutput = false;
    },

    //putStartInfo
    putStartInfoRequest(state) {
        state.putStartInfoOutput = null;
    },
    putStartInfoSuccess(state, output) {
        state.putStartInfoOutput = true;
    },
    putStartInfoFailure(state) {
        state.putStartInfoOutput = false;
    },

    //getStartInfoDetails
    getStartInfoDetailsRequest(state) {
    },
    getStartInfoDetailsSuccess(state, output) {
        state.getStartInfoDetailsOutput = output;
    },
    getStartInfoDetailsFailure(state) {
        state.getStartInfoDetailsOutput = false;
    },

    //deleteStartInfoById
    deleteStartInfoByIdRequest(state) {
        state.deleteStartInfoByIdOutput = null;
    },
    deleteStartInfoByIdSuccess(state, output) {
        state.deleteStartInfoByIdOutput = true;
    },
    deleteStartInfoByIdFailure(state) {
        state.deleteStartInfoByIdOutput = false;
    },
};

export const startInfos = {
    namespaced: true,
    state,
    actions,
    mutations
};